import { render, staticRenderFns } from "./NotificationsComponent.vue?vue&type=template&id=7ada4326&scoped=true&"
import script from "./NotificationsComponent.vue?vue&type=script&lang=js&"
export * from "./NotificationsComponent.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsComponent.vue?vue&type=style&index=0&id=7ada4326&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ada4326",
  null
  
)

export default component.exports